export default "__VITE_ASSET__7dKvxFbz__"